export class Debouncer {
    delayInMilliseconds = 450;
    timeoutId = null;
    lastDelay = null;
  
    constructor(delayInMilliseconds) {
      if (delayInMilliseconds > 0) {
        this.delayInMilliseconds = delayInMilliseconds;
      }
    }
  
    debounce = function(callback) {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
      }
  
      this.timeoutId = setTimeout(callback, this.delayInMilliseconds);
    }

    cancel = function() {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
    
    delay = function(callback) {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      const now = Date.now();
      const diff = now - this.lastDelay;
      if (this.lastDelay !== null && diff < this.delayInMilliseconds) {
        this.timeoutId = setTimeout(() => {
          this.lastDelay = Date.now();
          callback();
        }, this.delayInMilliseconds - diff)
        return;
      }
      this.lastDelay = now;
      callback();
    }
}


// WEBPACK FOOTER //
// ./src/utils/debouncer.js